import React, { useState } from 'react';
import {
  withStyles,
  MuiThemeProvider,
  createTheme,
} from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import NavigateBefore from '@material-ui/icons/NavigateBefore';
import NavigateNext from '@material-ui/icons/NavigateNext';
import GetAppIcon from '@material-ui/icons/GetApp';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import green from '@material-ui/core/colors/green';
import { Link } from 'react-router-dom';
import { Translation } from 'react-i18next';
import { object } from 'prop-types';
import VisaDetails from './VisaDetails';
import PersonalDetails from './PersonalDetails';
import PassportDetails from './PassportDetails';
import ContactDetails from './ContactDetails';
import SupportingDocuments from './SupportingDocuments';
import Payment from './Payment';
import Footer from '../../scenes/components/Footer';

const finalStatuses = ['SUBMITTED', 'REJECTED', 'APPROVED'];

const styles = theme => ({
  mainForm: {
    flexGrow: 1,
    padding: theme.spacing(2),
    borderWidth: 2,
    marginTop: theme.spacing(10),
  },
  applicationInfo: {
    marginBottom: theme.spacing(4),
  },
  buttonBackTo: {
    backgroundColor: '#0280CA',
    color: '#ffffff',
  },
  buttonNext: {
    background: '#357a38',
  },
  rightIcon: {
    marginLeft: theme.spacing(1),
  },
  leftIcon: {
    marginRight: theme.spacing(1),
  },
  buttonContainer: {
    padding: theme.spacing(2),
  },
  buttonLeftContainer: {
    display: 'flex',
  },
  buttonRightContainer: {
    justifyContent: 'flex-end',
    display: 'flex',
    columnGap: theme.spacing(2),
  },
  buttonBack: {
    backgroundColor: '#b22a00',
  },
  field: {
    padding: theme.spacing(2),
  },
  buttonDownloadPDF: {
    backgroundColor: '#0280CA',
    color: '#ffffff',
  },
  formControlContainer: {
    paddingLeft: theme.spacing(2),
    paddingTop: theme.spacing(2),
  },
  checkRoot: {
    color: green[600],
    '&$checked': {
      color: green[500],
    },
  },
  checked: {},
});

const theme = createTheme({
  palette: {
    primary: {
      main: '#6fbf73',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#f50057',
      contrastText: '#ffffff',
    },
  },
  typography: {
    useNextVariants: true,
  },
});

function ApplicationForm(props) {
  const { classes, application, history, downloadApplicationRequest } = props;

  const [checked, setChecked] = useState(false);

  const handleChange = event => {
    setChecked(event.target.checked);
  };

  return (
    <Translation>
      {t => {
        return (
          <Grid
            container
            alignItems="center"
            direction="row"
            justifyContent="center"
            className={classes.mainForm}
          >
            <Grid item xs={11}>
              <Typography variant="h4" align="center" gutterBottom>
                {t('applicationSummaryTitle')}
              </Typography>
            </Grid>
            <Grid item xs={11}>
              <VisaDetails readOnly />
            </Grid>
            <Grid item xs={11}>
              <PersonalDetails readOnly />
            </Grid>

            <Grid item xs={11}>
              <ContactDetails readOnly />
            </Grid>
            <Grid item xs={11}>
              <PassportDetails readOnly />
            </Grid>
            <Grid item xs={11}>
              <SupportingDocuments readOnly />
            </Grid>

            {(!!application.feeAmount ||
              application.status === 'SUBMITTED') && (
              <Grid item xs={11}>
                <Payment readOnly application={application} />
              </Grid>
            )}

            {!finalStatuses.includes(application.status) &&
              application.status !== 'CANCELLED' && (
                <Grid
                  container
                  xs={11}
                  className={classes.formControlContainer}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={checked}
                        onChange={handleChange}
                        classes={{
                          root: classes.checkRoot,
                          checked: classes.checked,
                        }}
                      />
                    }
                    label={
                      <span>
                        {t('confirmPDF')} <b>{t('biometricPhoto')}</b>{' '}
                        {t('submitted')}
                      </span>
                    }
                  />
                </Grid>
              )}

            <Grid
              container
              alignItems="center"
              justifyContent="space-between"
              direction="row"
              xs={11}
              className={classes.buttonContainer}
            >
              <Grid item xs={4} className={classes.buttonLeftContainer}>
                <MuiThemeProvider theme={theme}>
                  <Button
                    variant="contained"
                    color="primary"
                    component={Link}
                    to={'/applications'}
                    className={classes.buttonBackTo}
                  >
                    <NavigateBefore className={classes.leftIcon} />
                    {t('backTo')}
                  </Button>
                </MuiThemeProvider>
              </Grid>
              <Grid item xs={7} className={classes.buttonRightContainer}>
                <MuiThemeProvider theme={theme}>
                  {!finalStatuses.includes(application.status) &&
                    application.status !== 'CANCELLED' && (
                      <Button
                        variant="contained"
                        color="secondary"
                        component={Link}
                        to={'/documents'}
                        className={classes.buttonBack}
                      >
                        <NavigateBefore className={classes.leftIcon} />
                        {t('back')}
                      </Button>
                    )}

                  <Button
                    variant="contained"
                    startIcon={<GetAppIcon />}
                    color="primary"
                    className={classes.buttonDownloadPDF}
                    onClick={downloadApplicationRequest}
                  >
                    {t('downloadPDF')}
                  </Button>

                  {!finalStatuses.includes(application.status) &&
                    application.status !== 'CANCELLED' && (
                      <Button
                        variant="contained"
                        color="primary"
                        className={classes.buttonNext}
                        disabled={!checked}
                        onClick={() => {
                          history.push('/declaration');
                        }}
                      >
                        {t('continue')}
                        <NavigateNext className={classes.rightIcon} />
                      </Button>
                    )}
                </MuiThemeProvider>
              </Grid>
            </Grid>

            <Footer />
          </Grid>
        );
      }}
    </Translation>
  );
}

ApplicationForm.propTypes = {
  classes: object.isRequired,
};

export default withStyles(styles)(ApplicationForm);



// WEBPACK FOOTER //
// ./src/view/forms/Application/ApplicationForm.js